// client/src/components/pages/LocationAnalytics/defaultRange.ts
//
// The period Location Analytics opens on (ST-00229, audit ANL-19): this month up
// to yesterday. On the 1st that range would be inverted (start = today, end =
// yesterday) and the page opened on "No data", so on the 1st it is the whole
// previous month instead — the same rule as Product Movement.
import { toApiDateString } from '../../../utils/dateUtils';

export interface DateRangeStrings {
  /** YYYY-MM-DD */
  startDate: string;
  /** YYYY-MM-DD */
  endDate: string;
}

export function defaultDrillRange(today: Date = new Date()): DateRangeStrings {
  const y = today.getFullYear();
  const m = today.getMonth();
  if (today.getDate() === 1) {
    return {
      startDate: toApiDateString(new Date(y, m - 1, 1)),
      endDate: toApiDateString(new Date(y, m, 0)), // day 0 = the last day of the previous month
    };
  }
  return {
    startDate: toApiDateString(new Date(y, m, 1)),
    endDate: toApiDateString(new Date(y, m, today.getDate() - 1)),
  };
}
